// extracted by mini-css-extract-plugin
export default {"filter--item":"FilterItem_filter--item__xUiA5"};